'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.notify_list_show', {
        url: 'notify_list/:id',
        template: '<notify-list-show></notify-list-show>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/notify_list/show/notify_list_show.routes.js